import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ParadigmaModal from "../../../components/ParadigmaModal/ParadigmaModal.js"
import api from "../../../api";
import PlantillaFormSections from "./PlantillaFormSections.js";

class Create extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isOpen: false,
            descripcion: '',
            asunto: '',
            cuerpo: ''
        };

        this.getData = this.getData.bind(this);
    }

    static propTypes = {
        onSubmit: PropTypes.func,        
        nav: PropTypes.any
    }

    getData() {
        const { descripcion, asunto, cuerpo } = this.state;
        return {
            descripcion,
            asunto,
            cuerpo
        };
    }

    resetForm() {
        this.setState({
            isOpen: false,
            descripcion: '',
            asunto: '',
            cuerpo: ''
        });
        if (this.props.onClose) this.props.onClose();
    }


    onCuerpoChange = html => this.setState({ cuerpo: html });

    render() {
        return (
            <span>
            <ParadigmaModal
                onPreSubmit={this.getData}
                postUrl={api.email.plantillas.create}
                navButton={(this.props.nav ? true : false)}
                nav={this.props.nav}
                onSubmit={(e) => this.props.onSubmit(e)}
                successMessage={"La Plantilla de Mail ha sido generada con éxito."}
                title={"Nueva Plantilla de Mail"}
                buttonTitle={"Nueva"}
                className={"ui-modal-dialog ui-modal-editor"}
                buttonIcon={"fa fa-plus fa-lg"}
                saveButton={true}
                closeButton={true}
                onClose={() => this.resetForm()}
                initOpen={this.props.initOpen}
                backdrop={false}
                cancelButtonLabel="Cancelar"
            >
                <div className="ui-form">
                    <PlantillaFormSections
                        autoFocusFirstField={true}
                        descripcion={this.state.descripcion}
                        asunto={this.state.asunto}
                        cuerpo={this.state.cuerpo}
                        onDescripcionChange={e => this.setState({ descripcion: e.target.value })}
                        onAsuntoChange={e => this.setState({ asunto: e.target.value })}
                        onCuerpoChange={this.onCuerpoChange}
                    />
                </div>
            </ParadigmaModal>
            </span>
        );
    }
}

export default Create;



// WEBPACK FOOTER //
// ./src/views/Config/Plantillas/Create.js